import { Popover, type PopoverProps } from '@stenajs-webui/tooltip';
import type { FC } from 'react';
import { getPortalRoot } from '../../use-cases/manage/grid/utils/getPortalRoot';

const portalRoot = getPortalRoot();

export type Placement = PopoverProps['placement'];

export interface FreightPortalPopoverProps
  extends Omit<PopoverProps, 'disablePadding' | 'hideArrow'> {
  enablePadding?: boolean;
}

export const FreightPortalPopover: FC<FreightPortalPopoverProps> = ({
  enablePadding = false,
  appendTo,
  ...props
}) => {
  return (
    <Popover
      {...props}
      hideArrow={true}
      disablePadding={!enablePadding}
      trigger={'click'}
      appendTo={appendTo ?? portalRoot}
    />
  );
};
